import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export default function HeaderBlock() {

    const location = useLocation();
    const navigate = useNavigate();


    useLayoutEffect(() => {
        //document.documentElement.scrollTo(0, 0);
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant", // Optional if you want to skip the scrolling animation
        });
    }, [location.pathname]);



    return (
        <>
            <div id="header">
                <Navbar expand="lg" className="bg-body-tertiary">
                    <Container fluid="lg">
                        <Navbar.Brand as={Link} to="/">Lerobot Controller</Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Link as={Link} to="/">Home</Nav.Link>
                                <Nav.Link as={Link} to="/about">About</Nav.Link>
                                <NavDropdown title="More">
                                    <NavDropdown.Item as={Link} to="/code">Code</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/repo">Repository</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item as={Link} to="/waveshare">Waveshare</NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        </>
    );
};